'use client';

import { useContext } from 'react';
import { MeContext } from '../../../../../providers/Me';
import { redirect } from 'next/navigation';
import NotFoundState from '../../../../../components/NotFoundState';
import { LoginPath, MyConnectionsPath } from '../../../../../lib/paths';

export default function NotFoundPage() {
  const { isAuthenticated } = useContext(MeContext);

  return isAuthenticated ? (
    <NotFoundState homeHref={MyConnectionsPath} />
  ) : (
    redirect(LoginPath)
  );
}
